var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7713_6411)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M15.6535 28.947L4.13183 29.3909C3.43352 29.4165 2.74084 29.2558 2.12324 28.9251C1.50564 28.5943 0.984805 28.1054 0.612926 27.5069C0.24105 26.9085 0.0311962 26.2217 0.0043982 25.5154C-0.0223999 24.809 0.134799 24.108 0.460239 23.4825L5.83322 13.1633L11.229 2.85248C11.5554 2.22677 12.039 1.69905 12.631 1.3224C13.2231 0.945741 13.9028 0.733434 14.6017 0.70683C15.3006 0.680225 15.9941 0.840261 16.6125 1.17084C17.2308 1.50142 17.7522 1.99089 18.1242 2.59001L24.2619 12.4616L30.3988 22.3366C30.771 22.9354 30.9808 23.6228 31.0072 24.3297C31.0335 25.0366 30.8755 25.738 30.5488 26.3635C30.2222 26.989 29.7383 27.5164 29.1461 27.8927C28.5542 28.2691 27.8745 28.4811 27.1757 28.5075L15.6535 28.947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M19.7645 20.1098L31.29 19.6961C31.9872 19.6731 32.6782 19.8358 33.2937 20.1678C33.9092 20.4998 34.4276 20.9895 34.7973 21.5879C35.167 22.1863 35.3747 22.8723 35.3999 23.5775C35.4251 24.2827 35.2669 24.9821 34.9408 25.6059L29.5414 35.9165L24.138 46.2163C23.8097 46.8414 23.3246 47.368 22.7314 47.7431C22.1382 48.1185 21.4578 48.3291 20.7586 48.3543C20.0594 48.3793 19.366 48.2178 18.748 47.886C18.1301 47.5542 17.6093 47.0636 17.2381 46.4637L11.1231 36.5766L5.00822 26.6905C4.63643 26.0909 4.42737 25.4029 4.40202 24.6955C4.37671 23.9882 4.53601 23.2866 4.86392 22.6614C5.19186 22.0362 5.67679 21.5094 6.26999 21.134C6.86316 20.7587 7.54361 20.548 8.24287 20.5232L19.7645 20.1098Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7713_6411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.6571,
    height: 48,
    fill: "white",
    transform: "translate(0 0.623169)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWt);
export default __webpack_public_path__ + "static/media/logo_wt.d24258ca6f659b0e5f50713c39af604f.svg";
export { ForwardRef as ReactComponent };